jQuery(document).ready(function ($) {
  // make .gf_readonly inputs readonly in gravity forms
  document.addEventListener("gform/postRender", (event) => {
    const form = gform.utils.getNode(
      `#gform_${event.detail.formId}`,
      document,
      true
    );
    const inputs = Array.from(
      gform.utils.getNodes(".gf_readonly input", false, form, true)
    );

    inputs.forEach((input) => {
      input.readOnly = true;
    });
  });

  // Function to format date as dd/mm/yyyy hh:mm
  function formatDateTime() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  // Store which signature field opened the modal
  let activeSignatureFieldId = null;

  // Listen for when "Adopt and Sign" button is clicked to track which field is active
  $(document).on("click", ".legalsigning-field-signature__adopt", function (e) {
    const $signatureField = $(this).closest(".legalsigning-field-signature");
    if ($signatureField.length > 0) {
      activeSignatureFieldId = $signatureField.attr("id");
    }
  });

  // Listen for ForGravity Legal Signing modal primary button clicks (final signature confirmation)
  $(document).on(
    "click",
    ".legalsigning-field-signature__footer-button--primary",
    function (e) {
      // Prevent event bubbling that might cause multiple triggers
      e.preventDefault();
      e.stopPropagation();

      // Check if the button is active/enabled
      if ($(this).prop("disabled") || $(this).hasClass("disabled")) {
        return;
      }

      // ONLY process if we have a valid active signature field ID
      // Remove fallback logic to prevent wrong field targeting
      if (!activeSignatureFieldId) {
        return;
      }

      const match = activeSignatureFieldId.match(
        /legalsigning-field-signature-(\d+)/
      );
      if (!match) {
        return;
      }

      const fieldIndex = match[1];

      // Try to find the timestamp field
      let $timestampField = $(`.timestamp_field_${fieldIndex}`);

      // If it's not a direct input, try to find input inside it
      if ($timestampField.length > 0 && !$timestampField.is("input")) {
        const $inputInside = $timestampField.find("input");
        if ($inputInside.length > 0) {
          $timestampField = $inputInside;
        }
      }

      if ($timestampField.length > 0) {
        // Always update timestamp when signature is confirmed
        const timestamp = formatDateTime();
        $timestampField.val(timestamp);

        // Trigger change event to ensure form recognizes the change
        $timestampField.trigger("change");

         // Clear the active field after processing
         activeSignatureFieldId = null;
       }
     }
   );
});
